import { AgentDropdown } from "../../components/ui/agent-dropdown";

export function AgentSelect({
  value,
  onChange,
  includeAll = true,
  label,
  exclude = [],
  align = "right",
  className,
}: {
  value: string;
  onChange: (agentId: string) => void;
  includeAll?: boolean;
  label?: string;
  exclude?: string[];
  align?: "left" | "right";
  className?: string;
}) {
  return (
    <div className="flex flex-col gap-1">
      {label && <label className="text-[11px] font-medium text-ink-3">{label}</label>}
      <AgentDropdown
        value={{ agent_id: value || undefined }}
        onChange={(val) => onChange(val.agent_id || val.workflow_id || "")}
        align={align}
        includeAll={includeAll}
        exclude={exclude}
        className={
          className ??
          "h-8 px-2.5 py-1 text-xs font-medium rounded-lg border border-line bg-elevated text-ink hover:bg-soft min-w-[10rem] shadow-xs"
        }
      />
    </div>
  );
}
